import { NgModule, enableProdMode, LOCALE_ID } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, BaseRequestOptions } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { AppRoutingModule, routingComponents } from './app.routes';
import { TagInputModule } from 'ngx-chips';

import { SharedModule } from './shared/shared.module';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
// import * as _moment from 'moment';
// import {default as _rollupMoment} from 'moment';

// import { MatMomentDateModule } from '@angular/material-moment-adapter';
// import * as moment from 'moment';
import { MomentModule } from 'angular2-moment';
import {
  // MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import * as _moment from 'moment';
_moment.locale('en');
console.log(_moment().calendar());

import {
  // NativeDateAdapter,
  MatNativeDateModule, MatSliderModule
} from '@angular/material';
import {
  MatButtonModule, MatInputModule, MatCardModule, MatToolbarModule,
  MatMenuModule, MatIconModule, MatSidenavModule, MatCheckboxModule,
  MatTabsModule, MatSelectModule, MatAutocompleteModule, MatListModule,
  MatTableModule, MatSortModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatDatepickerModule, MatExpansionModule, MatDialogModule, MatTooltipModule, MatSlideToggleModule, GestureConfig
} from '@angular/material';
import { ToasterModule } from 'angular2-toaster';
import { CdkTableModule } from '@angular/cdk/table';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { AgmCoreModule } from '@agm/core';
// Helpers
import { GlobalsPaths, GoogleMapsKey, APIsettings } from './app.config';
// import { Utilities } from './_utilities/Utilities';

// Pipes
// import { StringifyUnitPipe } from './_pipes/stringify-unit.pipe';

// import { MOMENT_DATE_FORMATS } from "./_utilities/MomentDateFormats";

// -- services
import { NgxPermissionsModule } from 'ngx-permissions';
import { AuthGuard } from './_guards/auth.guard';
import { AuthenticationService } from './_services/index';
import { HttpClient } from './_services/global-http.service';
import { UsersService } from './_services/users.service';
import { TrackerService } from './_services/trackers.service';
import { UploadVehiclesService } from './_services/upload-vehicles.service';
import { PermissionService } from './_services/permission.service';
import { ChangePasswordService } from './_services/change-password.service';
import { NewUserService } from './_services/new-user.service';
import { CustomersService } from './_services/customers.service';
import { VehiclesService } from './_services/vehicles.service';
import { VehiclesGroupsService } from './_services/vehicles-groups.service';
import { VehiclesTimesheetService } from './_services/vehicle-timesheet.service';
import { TripService } from './_services/trip.service';
import { TripDetailService } from './_services/trip-detail.service';
import { TrackService } from './_services/track.service';
import { TraceService } from './_services/trace.service';
import { VehicleMessageService } from './_services/vehicle-message.service';
import { ToasterErrorService } from './_services/toaster.service';
import { ResetPasswordService } from './_services/reset-password.service';
import { UnauthorisedComponent } from './unauthorised/unauthorised.component';
import { RegistrationSearchService } from './_services/registration-search.service';

import { GoogleMapsService } from './_services/google-maps.service';
import { RegionDepotListService } from './_services/region-depot-list.service';
import { VehiclesHelpQrService } from './_services/vehicle-help-qrcode.service';
import { GeofenceService } from './_services/geofence.service';

// -- components
import { ForgotPasswordComponent } from './Forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './Reset-password/reset-password.component';
import { SetPasswordComponent } from './Set-password/set-password.component';

import { AppComponent } from './app.component';
import { LoginComponent } from './Login/login.component';
import { HomeComponent } from './Home/home.component';

import { CommonService } from './_services/common.service';
import { StatsService } from './_services/stats.service';
import { ReportsService } from './_services/reports.service';
import { BehaviourService } from './_services/behaviour.service';
import { NotificationEmailsService } from './_services/notification-emails.service';

// Dialogs
import { HttpErrorDialog } from './Dialogs/HttpErrorDialog/http-error-dialog';
import { DialogsService } from './_services/dialogs.service';
import { GeneralDialog } from './Dialogs/GeneralDialog/general-dialog';
import { VideoRequestDialog } from './Dialogs/VideoRequestDialog/video-request-dialog';
import { VideoLiveSnapshotDialog } from './Dialogs/VideoLiveSnapshotDialog/video-live-snapshot-dialog';
import {VehicleFileModule} from './Vehicle-file/vehicle-file.module';
import {VehiclesFilesService} from './_services/vehicles-files.service';
import { QrLandingPageComponent } from './QR-code/components/qr-landing-page/qr-landing-page.component';
import { CookieService } from 'ngx-cookie-service';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Http} from '@angular/http';
import { LanguagesStaticText } from './_services/language.servic';
// import { fromPromise } from 'rxjs/observable/fromPromise';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    // dateInput: `MM/DD/YYYY`,
    dateInput: `DD/MM/YYYY`,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};
function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
enableProdMode();

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    // Angular permission library
    NgxPermissionsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MomentModule,
    MatButtonModule, MatInputModule, MatCardModule, MatToolbarModule, MatMenuModule, MatIconModule, MatSidenavModule,
    MatCheckboxModule, MatTabsModule, MatSelectModule, MatAutocompleteModule, MatListModule, MatTableModule, MatSortModule,
    MatPaginatorModule, MatProgressSpinnerModule, MatDatepickerModule, MatExpansionModule, MatDialogModule, MatTooltipModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatNativeDateModule,
    CdkTableModule,
    HttpModule,
    TagInputModule,
    ToasterModule,
    MyDateRangePickerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDmbRsQfIbAGVwt2y_4T560tf3nsx2ZUyw',
      language: 'en',
      libraries: ['geometry', 'places', 'drawing']
    }),
    TranslateModule.forRoot(
      // {
      // loader: {
      //   provide: TranslateLoader,
      //   useFactory: (createTranslateLoader),
      //   deps: [Http]
      // }
    // }
    ),
    SharedModule,
    VehicleFileModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SetPasswordComponent,
    UnauthorisedComponent,
    routingComponents,
    HttpErrorDialog,
    GeneralDialog,
    VideoRequestDialog,
    VideoLiveSnapshotDialog,
    QrLandingPageComponent
  ],
  entryComponents: [
    HttpErrorDialog,
    GeneralDialog,
    VideoRequestDialog,
    VideoLiveSnapshotDialog
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    CookieService,
    AuthGuard,
    AuthenticationService,
    HttpClient,
    UsersService,
    TrackerService,
    PermissionService,
    ChangePasswordService,
    CommonService,
    NewUserService,
    LanguagesStaticText,
    CustomersService,
    VehiclesService,
    VehiclesGroupsService,
    VehiclesTimesheetService,
    TripService,
    TripDetailService,
    TrackService,
    TraceService,
    VehicleMessageService,
    ToasterErrorService,
    ResetPasswordService,
    GlobalsPaths,
    GoogleMapsKey,
    APIsettings,
    BaseRequestOptions,
    DatePipe,
    GoogleMapsService,
    RegionDepotListService,
    ReportsService,
    StatsService,
    BehaviourService,
    DialogsService,
    VehiclesHelpQrService,
    UploadVehiclesService,
    GeofenceService,
    NotificationEmailsService,
    RegistrationSearchService,
    VehiclesFilesService,
    { provide: LOCALE_ID, useValue: 'en-GB' },
    // {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},

    // moment adaptor
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], useValue: 'en-GB' },
    // {provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS},

    // {provide: DateAdapter, useClass: MyDateAdapter},
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },

    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }
  ]
})

export class AppModule { }



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/app.module.ts